import APIClient from '../../../common/APIClient';
import { displayError } from '../commonActions';
import { fetchPlatforms, fetchPlatformBands, SET_PROJECT_PLATFORMS } from '../platforms/platformActions';
import { fetchProjectScope, 
  fetchProjectCostings, 
  combineTaskDistributionAndBands } from '../projects/projectCostingActions';
import { fetchProjectTasks } from '../projects/projectTasksActions';
import { fetchProjectMembers } from '../projects/projectMembersActions';
import { setNumAttachments } from '../projects/projectAttachments';
import { SET_APPROVERS } from '../projects/projectsActions';

const SET_PROJECT_FOR_APPROVAL = 'SET_PROJECT_FOR_APPROVAL';
const RESET_PROJECT_FOR_APPROVAL = 'RESET_PROJECT_FOR_APPROVAL';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

  
export const getAuditTrail = (projectId) => {
  return (dispatch) => {
    client().get(
      '/audit-trail/get', {
        params: {
          target_id: projectId,
          table_name: 'projects'
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        const data = result.data;
        if (Object.keys(data.record_details).length && data.record_details) {
          const forApproval = JSON.parse(data.record_details);

          let arrPlatformIds = [];

          if (forApproval) {
            Object.assign(forApproval, {id: projectId});
            dispatch({type: SET_PROJECT_FOR_APPROVAL, forApproval});
            if (forApproval.project_platform.length) {
              forApproval.project_platform.forEach(platform => {
                arrPlatformIds.push(platform.id);
              })

              Object.assign(forApproval, {platform: arrPlatformIds});
            }

            dispatch(fetchProjectTasks());
            dispatch(fetchProjectMembers(forApproval.id, false));
            dispatch(fetchProjectScope({project_id: forApproval.id}, arrPlatformIds));
            dispatch(fetchProjectCostings({project_id: forApproval.id}));
            
            if (typeof(forApproval.project_attachments) !== "undefined") {
              let numAttachments = forApproval.project_attachments.length;

              if (!numAttachments) {
                numAttachments = 1;
              }
              dispatch(setNumAttachments(numAttachments));
            }

            if (forApproval.project_platform.length) {
              dispatch(fetchPlatforms({id: arrPlatformIds}, true));

              dispatch(fetchPlatformBands({
                platform_id: arrPlatformIds, 
                fully_loaded: forApproval.fully_loaded, 
                year: forApproval.costing_year}, true));
            }
            else {
              dispatch({type: SET_PROJECT_PLATFORMS, projPlatforms: null});
            }

            let approvers = forApproval.project_approvers;
            dispatch({type: SET_APPROVERS, approvers});


            setTimeout(() => {
              arrPlatformIds.length && arrPlatformIds.forEach(platformId => {
                dispatch(combineTaskDistributionAndBands(platformId));   
              })
            }, 4000)
          }
        }
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const resetForApproval = () => {
  return (dispatch) => {
    dispatch({type: RESET_PROJECT_FOR_APPROVAL});
  }
}